import './Project.css';
import ProjectCard from '../../components/ProjectCard/ProjectCard';

const Project = (props) => {
  return (
    <div className="Project">
      <h1>{props.heading}</h1>
      <div className='allProject'>
          <ProjectCard img={props.data[0].projectimg} name ={props.data[0].projectName} description={props.data[0].projectDescription} link={props.data[0].projectLink}/>
          <ProjectCard img={props.data[1].projectimg} name ={props.data[1].projectName} description={props.data[1].projectDescription} link={props.data[1].projectLink}/>
          <ProjectCard img={props.data[2].projectimg} name ={props.data[2].projectName} description={props.data[2].projectDescription} link={props.data[2].projectLink}/>
      </div>
      
    </div>
  );
}

export default Project;
